import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class PositionsService extends BaseService {
  static get entity() {
    return 'positions'
  }

  static async getPositionsList() {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
